import React from "react";
import { AlertTriangle } from "lucide-react";

import { Checkbox } from "../../../components/ui/checkbox";

import CampoMinimo from "./CampoMinimo";
import FotoProduto from "./FotoProduto";
import { piso, reais } from "./formato";

// Uma linha na campanha: produto inteiro, ou um tamanho de pizza (recuo).
export default function LinhaProdutoOferta({ nome, detalhe, foto, preco, custo, regra, padraoPct, onMudar, recuo = false }) {
  const pct = regra?.desconto_max_pct ?? "";
  const pctEfetivo = pct === "" ? padraoPct : Number(pct);
  const abaixoDoCusto = custo != null && piso(preco, pctEfetivo) < custo;

  return (
    <div className={`flex flex-wrap md:flex-nowrap items-center gap-x-3 gap-y-2 py-2.5 ${recuo ? "md:pl-8" : ""}`} data-e2e="linha-oferta">
      <Checkbox checked onCheckedChange={(v) => onMudar({ ...(regra || {}), participa: !!v })} aria-label={`Participa: ${nome}`} />
      {!recuo && <FotoProduto url={foto} nome={nome} />}
      <div className={`flex-1 min-w-[8rem] md:flex-none ${recuo ? "md:w-[12.5rem] lg:w-[14.5rem]" : "md:w-44 lg:w-52"}`}>
        <p className="text-sm font-semibold leading-tight">{nome}</p>
        <p className="text-[11px] text-muted-foreground tabular-nums mt-0.5">
          {detalhe ? `${detalhe} · ` : ""}{reais(preco)}
          {custo != null ? ` · custo ${reais(custo)}` : " · sem custo na ficha"}
        </p>
        {abaixoDoCusto && (
          <p className="text-[11px] text-red-500 font-semibold flex items-center gap-1 mt-1" data-e2e="alerta-custo">
            <AlertTriangle className="w-3 h-3" /> o valor mínimo fica abaixo do custo
          </p>
        )}
      </div>
      <CampoMinimo preco={preco} custo={custo} pct={pct} padraoPct={padraoPct}
        onPct={(novo) => onMudar({ ...(regra || {}), desconto_max_pct: novo })} />
    </div>
  );
}
